import styles from "./Button.module.scss";
import Spinner from "../Spinner";

type availableColors = "white" | "black" | "blue";
type basicColors =
  | "grey"
  | "primary"
  | "primary-filled"
  | "secondary"
  | "secondary-filled"
  | "no-color"
  | "black"
  | "black-filled"
  | "blurred"
  | "orange";
interface ButtonProps {
  children?: React.ReactNode;
  color?: basicColors;
  action: (data?: any) => void;
  disable?: boolean;
  forceColor?: boolean;
  loading?: boolean;
  loadingColor?: availableColors;
  border?: boolean;
  variant?: "regular" | "square";
}

const Button: React.FC<ButtonProps> = ({
  children,
  color = "default",
  action,
  disable = false,
  forceColor = false,
  loading = false,
  loadingColor = "white",
  border = true,
  variant = "regular",
}) => {
  const isBasicColor =
    color === "grey" ||
    color === "primary" ||
    color === "primary-filled" ||
    color === "secondary" ||
    color === "secondary-filled";
  const HoverEffect = isBasicColor ? "hover" : "";
  const buttonDisabled = forceColor
    ? color
    : disable
    ? loading
      ? color
      : "disable"
    : color;
  const defaultCursor = forceColor ? "cursorDefault" : "";
  const buttonBorder = border ? "" : "no-border";
  const actualAction = disable || loading ? void 0 : action;

  return (
    <button
      disabled={disable}
      className={`${styles.button} ${styles[buttonDisabled]} ${styles[defaultCursor]} ${styles[variant]} ${styles[buttonBorder]} ${styles[HoverEffect]}`}
      onClick={actualAction}
    >
      {loading ? <Spinner color={loadingColor} size="small" /> : children}
    </button>
  );
};

export default Button;
